<template>
  <el-popover
    v-model="visible"
    placement="bottom"
    width="280"
    trigger="click"
    popper-class="filter-header-popover"
    @show="handleShow"
  >
    <div class="filter-content">
      <!-- 文本筛选 -->
      <el-input
        v-if="!type || type === 'text'"
        v-model="innerValue"
        :placeholder="placeholder || `筛选${label}`"
        size="small"
        clearable
        @keyup.enter.native="handleConfirm"
        ref="filterInput"
      />
      <!-- 选项筛选 -->
      <el-select
        v-else-if="type === 'select'"
        v-model="innerValue"
        :placeholder="placeholder || `筛选${label}`"
        size="small"
        clearable
        style="width:100%"
      >
        <el-option v-for="opt in options" :key="opt.value" :label="opt.label" :value="opt.value" />
      </el-select>
      <!-- 日期区间筛选 -->
      <div v-else-if="type === 'daterange'" class="date-range-wrap">
        <el-date-picker
          v-model="innerValue"
          type="daterange"
          size="small"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          ref="filterDateRange"
          style="width:100%"
        />
      </div>
      <div class="filter-actions">
        <el-button size="mini" @click="handleReset">重置</el-button>
        <el-button size="mini" type="primary" @click="handleConfirm">筛选</el-button>
      </div>
    </div>
    <div slot="reference" class="filter-header">
      <span class="filter-label">{{ label }}</span>
      <i class="el-icon-search filter-icon" :class="{ active: hasValue }"></i>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'TableFilterHeader',
  props: {
    label: { type: String, required: true },
    placeholder: { type: String, default: '' },
    value: { type: [String, Number, Array], default: '' },
    // 类型：text(默认文本), select(选项), daterange(日期区间)
    type: { type: String, default: 'text' },
    // select 类型的选项列表：[{ label, value }]
    options: { type: Array, default: () => [] }
  },
  data() {
    return {
      visible: false,
      innerValue: this.value,
      // 快捷选项
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const start = new Date()
            picker.$emit('pick', [start, start])
          }
        }, {
          text: '最近7天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '本月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            start.setHours(0, 0, 0, 0)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    hasValue() {
      if (Array.isArray(this.value)) return this.value.length > 0
      return this.value !== '' && this.value !== null && this.value !== undefined
    }
  },
  watch: {
    value(val) {
      this.innerValue = val
    }
  },
  methods: {
    handleShow() {
      this.innerValue = this.value
      this.$nextTick(() => {
        if (this.type === 'daterange' && this.$refs.filterDateRange) {
          // 日期选择器自动聚焦
        } else if (this.$refs.filterInput) {
          this.$refs.filterInput.focus()
        }
      })
    },
    handleConfirm() {
      this.$emit('input', this.innerValue)
      this.$emit('filter', this.innerValue)
      this.visible = false
    },
    handleReset() {
      this.innerValue = this.type === 'daterange' ? [] : ''
      this.$emit('input', this.innerValue)
      this.$emit('filter', this.innerValue)
      this.visible = false
    }
  }
}
</script>

<style scoped>
.filter-header {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.filter-label {
  user-select: none;
}
.filter-icon {
  color: #C0C4CC;
  font-size: 13px;
  transition: color 0.2s;
}
.filter-icon.active {
  color: #409EFF;
}
.filter-content {
  padding: 4px 0;
}
.filter-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.date-range-wrap {
  width: 100%;
}
</style>
